import { GzComplexEnumFilterWebComponent } from './component/GzComplexEnumFilterWebComponent';

export { GzComplexEnumFilterWebComponent };
